import DateFnsUtils from '@date-io/date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import { MuiPickersUtilsProvider, TimePicker } from '@material-ui/pickers';
import { makeStyles } from '@material-ui/styles';


const useStyles = makeStyles(() => ({
  timePicker: {
    width: 50,
    float: 'right',
  },
}));

const TimePickerField = ({
  label,
  input: { name, value, onChange },
  meta: { touched, error, warning },
  timePickerProps,
  ...restProps
}) => {
  const classes = useStyles();

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <TimePicker
        showTodayButton
        label={label}
        value={value || new Date()}
        ampm={false}
        className={classes.timePicker}
        {...restProps}
        {...timePickerProps}
        onChange={onChange}
      />
    </MuiPickersUtilsProvider>
  );
};

TimePickerField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any,
  }).isRequired,
  label: PropTypes.string.isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool.isRequired,
    warning: PropTypes.string,
  }).isRequired,
};

export default TimePickerField;
